import { IBar, IPitch, IScoreEditorThis, TClef } from "../../../../../common/types";

export function handleChangeClef(this: IScoreEditorThis, clef: TClef, v: number) {
  const score = { ...this.state.score };
  score["clef" + (v || "")] = clef;
  this.setState({ score });
}

export function handleChangeDoClef(this: IScoreEditorThis, clef: boolean) {
  const score = { ...this.state.score };
  score["doClef"] = clef;
  this.setState({ score });
}

export function changeDoClefOffset(this: IScoreEditorThis, v: number, offset: number) {
  const score = { ...this.state.score };
  if (!score.doClefOffset) score.doClefOffset = [];
  score.doClefOffset[v] = offset;
  this.setState({ score });
}

export function handleChangeHideClefs(this: IScoreEditorThis, checked: boolean) {
  const score = { ...this.state.score };
  score.hideClefs = checked;
  this.setState({ score });
}

export function changeSolfaOctave(this: IScoreEditorThis, voice: number, amount: number) {
  const score = { ...this.state.score };
  const bars = score[`bars${voice || ""}`] as IBar[];
  score[`octave${voice}`] = (score[`octave${voice}`] || 0) + amount;
  bars.forEach(bar => {
      if (!bar) return;
      bar.notes.forEach(note => {
          if (note.p) {
              if (!(note.p as IPitch).o) {
                (note.p as IPitch).o = 0;
              }
              (note.p as IPitch).o! -= amount;
          }
      });
  });
  this.setState({ score });
}
